import React from 'react'
import css from './ScreenReaderText.module.css'

const ScreenReaderText = ({ tag, content }) => {
  const Tag = tag
  return <Tag className={css.srOnly}>{content}</Tag>
}

export default ScreenReaderText
